import React from 'react';
import { Event } from '../../../../stores/events';

const EventDates: React.FC<{ record: Event }> = React.memo(({ record }) => (
    <div className={'dates_holder'} style={{ padding: '4px 0' }}>
        <div
            className="text_center inline_block"
            style={{ marginRight: '12px' }}
        >
            <div style={{ marginBottom: '2px' }}>
                {record.startDate.format('ll')}
            </div>
            <div className={'lil_label'}>{record.startDate.format('LT')}</div>
        </div>
        {record.endDate && (
            <div className="text_center inline_block">
                <div style={{ marginBottom: '2px' }}>
                    {record.endDate.format('ll')}
                </div>
                <div className={'lil_label'}>{record.endDate.format('LT')}</div>
            </div>
        )}
    </div>
));
EventDates.displayName = 'EventDates';

export default EventDates;
